import types from './types';

export function setRow(row, key) {
  return { type: types.SET_ROW, row, key };
}

export default {
  setRow,
};
